import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import { LocalStorageKey } from '../_models/constants/local-storage';

@Injectable({
    providedIn: 'root'
})

export class RightGuard implements CanActivate {

    constructor(
        private router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredRight = route.data['right'];
        if (!requiredRight) {
            return true;
        }
        const userRights: string[] = JSON.parse(
            localStorage.getItem(LocalStorageKey.userRights) || '[]'
        );
        if (userRights.includes(requiredRight)) {
            return true;
        }
        this.router.navigate(['/app']);
        return false;
    }
}